import { isRouteErrorResponse, useRouteError } from '@remix-run/react';

import Page403 from './components/Page403';
import Page404 from './components/Page404';
import PageError from './components/PageError';

export default function ErrorBoundary() {
  const error = useRouteError();

  if (process.env.NODE_ENV === 'development') {
    console.error(error); // eslint-disable-line no-console
  }

  if (isRouteErrorResponse(error)) {
    if (error.status === 403) {
      return <Page403 />;
    }
    if (error.status === 404) {
      return <Page404 />;
    }
  }

  return <PageError />;
}
